import { FunctionZeroPad } from "radium-omnibus";
import {
  FunctionCreateDay,
  FunctionCreateHour,
  FunctionCreateMinute,
  FunctionCreateMonth,
  FunctionCreateYear,
} from "../../../utils/useFunction";

const BasketGenerateReference = (user) => {
  try {
    const month = FunctionCreateMonth();
    const day = FunctionCreateDay();
    const year = FunctionCreateYear();
    const hour = FunctionCreateHour();
    const minute = FunctionCreateMinute();

    const phoneNumber = user?.phone_number?.replace(
      `+${user?.phone_code}`,
      `${FunctionZeroPad(user?.phone_code, 4)}`
    );

    const referenceNumber = `${phoneNumber}-${FunctionZeroPad(
      day,
      2
    )}${FunctionZeroPad(month, 2)}${String(year).slice(-2)}-${FunctionZeroPad(
      hour,
      2
    )}${FunctionZeroPad(minute, 2)}`;
    return referenceNumber;
  } catch (error) {
    console.error("BasketGenerateReference", error);
  }
};

export default BasketGenerateReference;
